import { ENDPOINTS } from "@/api/application-api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Model } from "./types";
import { jsonAuthHeaders } from "@/utils/headers";

export const useEditCustomModel = (authToken: string) => {
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (model: Model) => {
      return fetch(
        ENDPOINTS.edit_custom_model(String(workspaceId), String(model.id)),
        {
          method: "PUT",
          body: JSON.stringify(model),
          headers: jsonAuthHeaders(authToken),
        },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", workspaceId],
      });
    },
  });
};
